module.exports = __webpack_public_path__ + "img/text-answer.e25a7b60.svg";